import logo from './logo.svg';
import auditLogo from './auditLogo.png';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import DeveloperPage from './Pages/DeveloperPage';
import OidcCallbackPage from './Pages/OidcCallbackPage';
import { getUserManagerAsync } from './Components/OidcConfig';
import TranscriptionComponent from './Components/Consultation/TranscriptionComponent';
import TranscriptionHistory from './Components/Consultation/TranscriptionHistory';
import ProtectedRoute from './Components/ProtectedRoute'
import { jwtDecode } from "jwt-decode";
import { ApiContextProvider } from './Contexts/ApiContext';
import { useApplication } from './Contexts/ApplicationContext';
import ErrorDisplay from './Components/ErrorDisplay';


function App() {

  const [userName, setUserName] = useState();
  const [isAdmin, setIsAdmin] = useState(false);
  const { isTranscribing, error, setError } = useApplication();

  useEffect(() => {
    authFunc();
  }, []);


  const authFunc = async () => {
    const userManager = await getUserManagerAsync();
    const user = await userManager.getUser();
    if (!user) {
      await userManager.signinRedirect();
    }
    else {
      console.log("User already logged in:", user);
      console.log("User", user);
      const decoded = jwtDecode(user.access_token);

      console.log("User roles", decoded.roles);
      if (decoded.roles && decoded.roles.find(x => x == "Admin")) {
        setIsAdmin(true);
      }

      const userName = decoded.unique_name || decoded.email || "Unknown User";

      setUserName(userName);
      console.log("User already logged in:", user);
    }
    
  }

  const logOut = async () => {
    const userManager = await getUserManagerAsync();
    userManager.clearStaleState();
    userManager.signoutRedirect();
  }

  const NavBar = () => {
    return (
      <nav className="shadow-md">
        <div class="bg-white flex items-center justify-between">
          <div class="ml-4">
            <img src={auditLogo} alt="Audit Logo" className=" w-40 h-14" />
          </div>
          <ul className="nav-links mt-4 mb-4">
            <li>
              <Link
                to="/new-consultation"
                className={`nav-link ${isTranscribing ? 'pointer-events-none text-gray-400' : ''}`}
              >
                New Consultation
              </Link>
            </li>
            <li>
              <Link
                to="/history"
                className={`nav-link ${isTranscribing ? 'pointer-events-none text-gray-400' : ''}`}
              >
                History
              </Link>
            </li>
            {isAdmin && (
              <li>
                <Link
                  to="/configuration"
                  className={`nav-link ${isTranscribing ? 'pointer-events-none text-gray-400' : ''}`}
                >
                  Configuration
                </Link>
              </li>
            )}
          </ul>
          <div className="user-section">
            {userName ? <span>{userName}</span> : null}
          </div>
          <button
            onClick={logOut}
            className={`mr-4 sign-out-btn flex items-center gap-2 ${isTranscribing ? 'pointer-events-none text-gray-400 bg-gray-100' : ''
              }`}
            disabled={isTranscribing}
          >
            Sign Out
          </button>
        </div>
      </nav>
    );
  };

  return (
    <ApiContextProvider>
      <Router>
        <div className="fixed h-screen w-screen">
          <NavBar />
          <ErrorDisplay
            error={error}
            onDismiss={() => setError([])}
          />
          <main className="h-[91vh] m-1" >
              <Routes>
                <Route element={<ProtectedRoute />}>
                  <Route
                    path="/new-consultation"
                    element={<TranscriptionComponent />}
                  />
                </Route>
                <Route element={<ProtectedRoute />}>
                  <Route path="/history" element={<TranscriptionHistory />} />
                </Route>
                <Route element={<ProtectedRoute />}>
                  <Route path="/configuration" element={<DeveloperPage />} />
                </Route>
                <Route path="/oidc-callback" element={<OidcCallbackPage />} />
                <Route path="/" element={<TranscriptionComponent />} />
              </Routes>
            </main>
        </div>
      </Router>
    </ApiContextProvider>
  );
}

export default App;
